import colorMod from 'color';

export default ({ color, fontSize, typography }) => ({
  root: {
    margin: '10px 0px',
    '& span': {
      display: 'inline',
    },
  },
  dateInput: {
    height: 30,
    width: 215,
    margin: '0 8px',
    paddingLeft: 5,
    border: `1px solid ${color.borderColor}`,
    borderRadius: '3px',
    color: 'inherit',
    fontSize: 13,
    fontFamily: typography.bodyText,
    '&:disabled': {
      color: color.bodyText,
      backgroundColor: colorMod(color.bodyText).alpha(0.05).string(),
    },
  },
  label: {
    color: color.bodyText,
    fontSize: fontSize.bodyText,
    fontFamily: typography.bodyText,
  },
});
